export const UISelectors = {
  loading(state) {
    return state.ui.loading;
  },
  notification(state) {
    return state.ui.notification;
  },
  headerText(state) {
    return state.ui.headerText;
  },
  displayTextItems(state) {
    return state.ui.displayTextItems;
  },
};
